/** Per-patient dashboard widget preference (DASHBOARD_WIDGETS_PLAN.md D-DASH-W2). */
export interface DashboardWidgetPref {
  id: string;
  enabled: boolean;
}

/** Default layout that seeds a new patient's dashboard — reproduces today's
 *  hardcoded dashboard so nothing changes visually until a user customizes. */
export const DEFAULT_DASHBOARD_LAYOUT: DashboardWidgetPref[] = [
  { id: "vitals",    enabled: true },
  { id: "weight",    enabled: true },
  { id: "today",     enabled: true },
  { id: "reminders", enabled: true },
  { id: "quick-log", enabled: true },
];

/**
 * Reconcile saved prefs against the live registry:
 * - keep saved order for known ids
 * - drop unknown ids (a widget that no longer exists)
 * - append registry widgets missing from saved prefs using their defaultEnabled
 *
 * This makes adding a new widget forward-compatible without a migration.
 */
export function resolveDashboardLayout(
  saved: DashboardWidgetPref[] | undefined,
  registryIds: { id: string; defaultEnabled: boolean }[],
): DashboardWidgetPref[] {
  if (!saved || saved.length === 0) {
    return registryIds.map(({ id, defaultEnabled }) => ({ id, enabled: defaultEnabled }));
  }
  const known = new Set(registryIds.map((r) => r.id));
  const result = saved.filter((p) => known.has(p.id));
  const savedIds = new Set(result.map((p) => p.id));
  for (const { id, defaultEnabled } of registryIds) {
    if (!savedIds.has(id)) result.push({ id, enabled: defaultEnabled });
  }
  return result;
}
